import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-pricing',
  templateUrl: './pricing.component.html',
  styles: [
  ]
})
export class PricingComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
